export const CONTENT_WIDTH = Object.freeze({
	narrow: 5,
	wide: 7,
	full: 12,
})
